<template>
  <div class="column justify-center items-center">
    <img
      :src="src"
      alt="Loading"
      :style="{ width: '365px', height: '143px' }"
    />
  </div>
</template>

<script>
export default {
  name: 'LoadingVehicle',
  computed: {
    src() {
      return `${process.env.BASE_URL}assets/images/LoadingVehicle.gif`;
    }
  }
};
</script>
